export default "__VITE_ASSET__C66_Y3TK__"